/* eslint-disable max-len */
import React from 'react';

var IconPlus = function IconPlus() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 8.75V16H8.75V8.75H16V7.25H8.75V0H7.25V7.25H0V8.75H7.25Z",
    fill: "#444749"
  }));
};

export default IconPlus;